import { render, staticRenderFns } from "./PxCompraPendenteAdmin.vue?vue&type=template&id=196332d8"
import script from "./PxCompraPendenteAdmin.vue?vue&type=script&lang=js"
export * from "./PxCompraPendenteAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports